<app-logged class="store-list">
  <header class="store-list__header">
    <h2>Páginas APP - Banners</h2>
    <div class="store-list__header__actions">
      <button class="btn-primary-light" mat-button (click)="goBack()">VOLTAR</button>
      <!-- <button class="btn-primary-light" mat-button routerLink="/dashboard/banner-page/new">
        ADICIONAR
      </button> -->
    </div>
  </header>

  <div class="table-responsive">
    <table mat-table [dataSource]="banners">
      <ng-container matColumnDef="page">
        <th mat-header-cell *matHeaderCellDef>Página</th>
        <td mat-cell *matCellDef="let element">{{ element.page }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Ações</th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-icon-button
            matTooltip="Banner"
            matTooltipPosition="left"
            routerLink="/dashboard/banners/home/{{ element.id }}"
          >
            <mat-icon>image</mat-icon>
          </button>
          <!-- <button
            mat-icon-button
            matTooltip="Editar"
            matTooltipPosition="left"
            routerLink="/dashboard/banner-page/{{ element.id }}/edit"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            mat-icon-button
            matTooltip="Remover"
            matTooltipPosition="left"
            (click)="remove(element.id)"
          >
            <mat-icon>delete</mat-icon>
          </button> -->
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="headersTable"></tr>
      <tr mat-row *matRowDef="let row; columns: headersTable"></tr>
    </table>
  </div>
</app-logged>
